var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          key: _vm.formContext.isInEditMode,
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Unfallgegner",
          },
          on: { save: _vm.saveAdversaryFormData },
          scopedSlots: _vm._u(
            [
              _vm.formContext.permissions.canCreateRetroactiveChangesNote ===
              true
                ? {
                    key: "after-icons",
                    fn: function () {
                      return [
                        _c("csp-retroactive-changes-modal", {
                          attrs: {
                            "record-id": _vm.recordId,
                            title: "Unfallgegner",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _vm.showChangelogButton
            ? _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c("csp-changelog-modal", {
                    attrs: { "changelog-url": _vm.adversaryChangelogUrl },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.recordId
            ? _c("csp-responsible-insurance-modal", {
                staticClass: "float-right mr-1",
                attrs: {
                  "button-size": "sm",
                  "record-id": Number.parseInt(_vm.recordId),
                },
                on: {
                  "success-responsible-insurance": function ($event) {
                    return _vm.$emit("reload-participants")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("h2", [_vm._v("Stammdaten")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Kennzeichen",
                      property: "cargo",
                      type: "text",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "display-value",
                          fn: function () {
                            return [
                              _c("csp-license-plate", {
                                attrs: {
                                  region: _vm.licensePlate.region,
                                  rest: _vm.licensePlate.rest,
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2356989945
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Anrede",
                  property: "gender",
                  required: true,
                  type: "radio",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: _vm.personLabelPrefix + "Titel",
                  property: "title",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: _vm.personLabelPrefix + "Vorname",
                  property: "firstName",
                  required: !_vm.isGenderCompany,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: _vm.personLabelPrefix + "Nachname",
                  property: "lastName",
                  required: !_vm.isGenderCompany,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Firmenname",
                  property: "companyName",
                  required: _vm.isGenderCompany,
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Straße",
                  property: "street",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "PLZ",
                  property: "postalCode",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Ort",
                  property: "place",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Land",
                  "options-loader": _vm.loadCountryOptions,
                  property: "country",
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h2", [_vm._v("Kontaktdaten")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Mobil",
                  property: "phone",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Telefon",
                  property: "mobile",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "E-Mail",
                  property: "email",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h2", { staticClass: "float-left" }, [
            _vm._v("\n        Versicherungsdaten\n    "),
          ]),
          _vm._v(" "),
          _vm.showChangelogButton
            ? _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c("csp-changelog-modal", {
                    attrs: {
                      "changelog-url": _vm.adversaryInsuranceChangelogUrl,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "clear-float" }),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Schadensnummer geg. Vers.",
                  property: "adversaryInsuranceReference",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Vertragsnummer",
                  property: "insurancePolicyNr",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shouldDisplayInsuranceParent,
                    expression: "shouldDisplayInsuranceParent",
                  },
                ],
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Versicherungskonzern",
                  "options-loader": _vm.loadInsuranceParentOptions,
                  property: "insuranceParent",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _vm.formContext.data.insuranceName
                            ? _c("span", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.formContext.data.insuranceName)
                                  ),
                                ]),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insurancePhone
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formContext.data.insurancePhone)
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insuranceEmail
                            ? _c("span", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "mailto:" +
                                        _vm.formContext.data.insuranceEmail,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.formContext.data.insuranceEmail
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4147792178
                ),
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shouldDisplayInsuranceBranch,
                    expression: "shouldDisplayInsuranceBranch",
                  },
                ],
                staticClass: "col-6",
                attrs: {
                  dependencies: ["insuranceParent"],
                  "form-context": _vm.formContext,
                  label: "Versicherungsfiliale",
                  "options-loader": _vm.loadInsuranceBranchOptions,
                  property: "insuranceBranch",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _vm.formContext.data.insuranceName
                            ? _c("span", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.formContext.data.insuranceName)
                                  ),
                                ]),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insurancePhone
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formContext.data.insurancePhone)
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insuranceEmail
                            ? _c("span", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "mailto:" +
                                        _vm.formContext.data.insuranceEmail,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.formContext.data.insuranceEmail
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4147792178
                ),
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }